import React from 'react';
import { KbArticle } from '../callCenterKnowledgeBaseTypes';
import styles from './ArticleList.module.css';

interface ArticleListProps {
  articles: KbArticle[];
}

export const ArticleList: React.FC<ArticleListProps> = ({ articles }) => {
  return (
    <div className={styles.grid}>
      {articles.map((article) => (
        <div key={article.id} className={styles.card}>
          <p className={styles.title}>{article.title}</p>
          <p className={styles.meta}>
            {article.category} · Updated {article.updated} · {article.readTime}
          </p>
        </div>
      ))}
    </div>
  );
};
